import ClientsAxios from "../client-axios";
import { ResponseEntity } from "../dto/response";
import { NotificationListRequest, S3FileDownloadRequest } from "../dto/request/notification";

const { RECRUITMENT_BASE_URL,COMMUNICATION_BASE_URL,ATTENDANCE_BASE_URL } = ClientsAxios;
export const NotificationListService = async (payload: NotificationListRequest) => {
    const responseEntity = new ResponseEntity<[]>()
    try {
        const response = await RECRUITMENT_BASE_URL.post('notification-listing', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.statusCode || 500, error.message, response.data?.message ? response.data.message : {})
    }
    return responseEntity
}
export const NotificationDetailsService = async (payload: any) => {
    const responseEntity = new ResponseEntity<[]>()
    try {
        const response = await COMMUNICATION_BASE_URL.post('notifications/list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.statusCode || 500, error.message, response.data?.message ? response.data.message : {})
    }
    return responseEntity
}
///notifications/update-notification-to-read
export const MarkAsReadNotificationService = async (payload: any) => {
    const responseEntity = new ResponseEntity<[]>()
    try {
        const response = await COMMUNICATION_BASE_URL.post('notifications/update-notification-to-read', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.statusCode || 500, error.message, response.data?.message ? response.data.message : {})
    }
    return responseEntity
}
//actionable/list
export const PendingActionNotificationService = async (payload: any) => {
    const responseEntity = new ResponseEntity<[]>()
    try {
        const response = await COMMUNICATION_BASE_URL.post('actionable/list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.statusCode || 500, error.message, response.data?.message ? response.data.message : {})
    }
    return responseEntity
}
//actionable/get-action-count
export const PendingActionNotificationCountService = async (payload: any) => {
    const responseEntity = new ResponseEntity<[]>()
    try {
        const response = await COMMUNICATION_BASE_URL.post('actionable/get-action-count', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.statusCode || 500, error.message, response.data?.message ? response.data.message : {})
    }
    return responseEntity
}
//communication//notification-action
export const ActionTrigerService = async (payload: any) => {
    const responseEntity = new ResponseEntity<[]>()
    try {
        const response = await ATTENDANCE_BASE_URL.post('notification-action', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.statusCode || 500, error.message, response.data?.message ? response.data.message : {})
    }
    return responseEntity
}

export const S3FileDownloadService = async (payload: S3FileDownloadRequest) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await ATTENDANCE_BASE_URL.post('s3-file-downlaod', payload,  {
            responseType: 'blob' 
       })
        responseEntity.success(response.data, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.statusCode || 500, error.message, response.data && response.data.message ? response.data.message : {})
    }
    return responseEntity
}
